import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Events } from 'src/api';
import { modalWindows } from 'src/actions/';

import HackHeader from './HackHeader';
import HackNavigation from './HackNavigation';
import HacksList from './HacksList';

import './Hackathons.scss';

import { Mixpanel } from '../Mixpanel';

const ALL_TAGNAME = 'Все';

const Loader = (props) => {
  return (
    <div className='account skeleton'>
      <div className="dual-loader"></div>
    </div>);
};

export const transformFetchedHackathons = (fetchedHackathons) => {
  const tags = [];
  const hackathons = fetchedHackathons.map((rawHackathon) => {
    const hackathon = {...rawHackathon};
    hackathon.tags = hackathon.tags.split(',');
    hackathon.tags.forEach((tag) => {
      if (tags.indexOf(tag) === -1 && tag!=="") {
        tags.push(tag);
      }
    });
    const start_date = hackathon.start_date;
    hackathon.start_date = moment(start_date);
    hackathon.end_date = moment(hackathon.end_date);
    hackathon.__week_start = moment(start_date).startOf('isoWeek');
    return hackathon;
  }).sort((a, b) => {
    return a.start_date.valueOf() - b.start_date.valueOf();
  });

  return {
    tags,
    hackathons,
  }
}

const EVENTS_REQUEST_LIMIT = 10;

class Hackathons extends Component {
  constructor() {
    super()
    this.state = {
      hackathons: [],
      fetchingHackathos: false,
      canLoadMoreHackathons: true,
      tags: [], // + Default tag: ALL_TAGNAME("Все")
      selectedTag: ALL_TAGNAME,
      eventsOffset: 0,
    }
  }

  componentDidMount() {
    Mixpanel.track('Page hackathons');
  }

  fetchHackathons = () => {
    if (this.state.fetchingHackathos) {
      return;
    }
    this.setState({
      fetchingHackathos: true,
    })
    return Events.getEvents(this.state.eventsOffset, EVENTS_REQUEST_LIMIT)
      .then(res => this.updateHackathons(res.data))
      .catch(error => console.error(error))
      .finally(() => {
        this.setState({
          fetchingHackathos: false,
        })
      })
  }

  unique = (a) => {;
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i] === a[j])
                a.splice(j--, 1);
        }
    }
    return a;
  };

  changeSelectedTag = (selectedTag) => {
    this.setState({
      selectedTag
    });
  }

  updateHackathons(fetchedHackathons) {
    const { tags, hackathons } = transformFetchedHackathons(fetchedHackathons);
    if (hackathons.length === 0) {
      this.setState({
        canLoadMoreHackathons: false,
      });
      return;
    }
    this.setState((state) => ({
        tags: this.unique(state.tags.concat(tags)),
        hackathons: state.hackathons.concat(hackathons), // TODO: should we sort them?
        eventsOffset: state.eventsOffset + EVENTS_REQUEST_LIMIT,
      })
    );
  }

  // selected via tagName selection
  getSelectedHackathons() {
    if (this.state.selectedTag === ALL_TAGNAME) {
      return this.state.hackathons;
    }
    const selectedHackathons = [];
    this.state.hackathons.forEach((hackathon) => {
      if (hackathon.tags.indexOf(this.state.selectedTag) > -1) {
        selectedHackathons.push(hackathon);
      }  
    });
    return selectedHackathons;
  }

  render() {
    return (
      <React.Fragment>
        <div className='hackathons'>
          <HackHeader></HackHeader>
          <HackNavigation
            hackathons={this.state.hackathons} 
            tags={this.state.tags} 
            selectedTag={this.state.selectedTag}
            onTagChange={this.changeSelectedTag}
          ></HackNavigation>
          <InfiniteScroll
            className='hackatones-wrapper'
            pageStart={0}
            loadMore={this.fetchHackathons}
            hasMore={this.state.canLoadMoreHackathons}
            loader={<div className="loader" key={0}></div>}
          >
            <HacksList
              hackathons={this.getSelectedHackathons()}
            ></HacksList>
          </InfiniteScroll>
          { this.state.fetchingHackathos ? <Loader /> : null }
        </div>
      </React.Fragment>
    );
  }
}

Hackathons.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  isAddHackModalOpened: PropTypes.bool.isRequired,
  openAddHackModal: PropTypes.func.isRequired,
  closeAddHackModal: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    isAddHackModalOpened: state.modalWindows.addHackathonOpened
  };
}

export default withRouter(
  connect(mapStateToProps, {
    openAddHackModal: modalWindows.openAddHackatonModal,
    closeAddHackModal: modalWindows.closeAddHackatonModal,
  })(Hackathons)
);



// WEBPACK FOOTER //
// ./src/components/Hackathons/index.js